module.exports = __webpack_public_path__ + "static/media/homeNoatecLat.b13302e3.png";